export default class EventObject2 {
  
  static _objectDefinition() {
      const options = {
        year: "numeric",
        month: "numeric",
        day: "numeric"
      };

      return {
        type:"",
        name: "",
        parentId: "",
        id: "",
        description: "",
        price: "",
        skew: "",
        planAble: false,
        intervalDuration:"" ,
        historicalArrivals:0 ,
        cloneForDays: "",
        startTime: null,
        endTime: null,
        startDate: null, //new Date().toLocaleDateString("nl-NL", options),
        endDate: null, //new Date().toLocaleDateString("en-EN", options),
        inflowCapacity: "",
        maxWaitTime: "",
        flexArrivalsPerc: "",
        AvgWaitingTime: "",
        MaxWaitingTime: "",
        AvgDeviation: "",
        MaxDeviation: "",
        sim: true,
        eventDuration:"",
        arrivalText:"",
        departureText:"",
        arrivalAudio:"",
        departureAudio:"",
        picture:"",
        destination:"",
        maxCapacity:'',

      };
  }

  static getPropertyId(name, columns) {
    for (let p in columns) {
      if (columns.hasOwnProperty(p) && p === name) {
        return columns[p];
      }
    }
  }

  static _parseEvalFactor(data, object) {
    if (data.hasOwnProperty("AvgDeviation")) {
      object.AvgDeviation = data.AvgDeviation;
    }
    if (data.hasOwnProperty("AvgWaitingTime")) {
      object.AvgWaitingTime = Math.ceil(Number(data.AvgWaitingTime) / 60);
    }
    if (data.hasOwnProperty("MaxWaitingTime")) {
      object.MaxWaitingTime = Math.ceil(Number(data.MaxWaitingTime) / 60);
    }
    if (data.hasOwnProperty("MaxDeviation")) {
      object.MaxDeviation = data.MaxDeviation;
    }
  }

  static _parseEventDataToObject3(event) {
    let object = this._objectDefinition();

    Object.entries(event).forEach(k => {
      switch (k[0]){
        case "intervalDuration":
        case "maxWaitTime":
        case "eventDuration":
        object[k[0]] = Number(k[1]) / 60;
        break;
        default:
        object[k[0]] = k[1];
      }
    });

    return object;
  }

  static _parseEventDataToObject2(event, columns) {
    let object = this._objectDefinition();

    for (let p in columns) {
      if (columns.hasOwnProperty(p)) {
        let index = columns[p];
        switch (p){
          case "intervalDuration":
          case "maxWaitTime":
          case "AvgWaitingTime":
          case "MaxWaitingTime":
          case "eventDuration":
          object[p] = Number(event[index]) / 60;
          break;
          default:
          object[p] = event[index];
        }
      }
    }
    return object;
  }

  static _getStringHours(time) {
    let stringTime = "";
    let startH = (time.getHours() < 10 ? "0" : "") + time.getHours();
    let startM = (time.getMinutes() < 10 ? "0" : "") + time.getMinutes();
    stringTime = startH + ":" + startM;
    return stringTime;
  }

  static _getStringDate(time) {}

  static _parseEventDataToObject(event) {

    let object = this._objectDefinition();

    object.id = event["id"];
    object.name = event["name"];
    object.description = event["description"];
    object.planAble = event["planAble"];
    object.skew = event["skew"];
    object.intervalDuration = Number(event["intervalDuration"]);
    object.historicalArrivals = event["historicalArrivals"];
    object.inflowCapacity = event["inflowCapacity"];
    object.cloneForDays = event["cloneForDays"];
    object.price = event["price"];
    object.parentId = event["parentId"];
    object.maxWaitTime = Number(event["maxWaitTime"]);
    object.flexArrivalsPerc = event["flexArrivalsPerc"];
    object.AvgWaitingTime = event["AvgWaitingTime"];
    object.MaxWaitingTime = event["MaxWaitingTime"];
    object.AvgDeviation = event["AvgDeviation"];
    object.MaxDeviation = event["MaxDeviation"];

    object.origStart = new Date(Number(event["startTime"]) * 1000);
    object.origEnd = new Date(Number(event["endTime"]) * 1000);

    // object.startDate = new Date(Number(event["startTime"]) * 1000);
    object.startTime = this._getStringHours(object.origStart);
    // object.endDate = new Date(Number(event["endTime"]) * 1000);
    object.endTime = this._getStringHours(object.origEnd);

    const isoStart = object.origStart.toISOString().split("T");
    object.startDate = isoStart[0];
    const isoEnd = object.origEnd.toISOString().split("T");
    object.endDate = isoEnd[0];

    return object;
  }

  static _createRequestObject(object, destinationId) {
    let start = new Date(object.startDate);
    let timeS = object.startTime.split(":");
    start.setHours(timeS[0]);
    start.setMinutes(timeS[1]);

    let end = new Date(object.endDate);
    let timeE = object.endTime.split(":");
    end.setHours(timeE[0]);
    end.setMinutes(timeE[1]);

    const creation = new Date();


    // const _id = destinationId + '_' + start.toLocaleDateString("nl-NL", Locales.optionYYYY_MM_DD) + '_' + creation.getTime();

    let requestObject = {
      id: object.id,
      name: object.name,
      parentId: object.parentId,
      historicalArrivals: object.historicalArrivals,
      startTime: start.getTime() / 1000,
      endTime: end.getTime() / 1000,
      price: Number(object.price).toFixed(2),
      planAble: object.planAble,
      cloneForDays: object.cloneForDays,
      skew: object.skew,
      intervalDuration: Number(object.intervalDuration) * 60,
      description: object.description,
      inflowCapacity: object.inflowCapacity,
      maxWaitTime: Number(object.maxWaitTime) * 60,
      flexArrivalsPerc: object.flexArrivalsPerc,
      sim: object.sim,
      eventDuration: Number(object.eventDuration) * 60,
    };
    return requestObject;
  }

  static _DeleteRequestObject(object,eventInst,eventComp) {
    let deleteRequestObject = {
      eventId: object.id,
      eventInstance: eventInst,
      eventComplete: eventComp
    };
    return deleteRequestObject;
  }
  static _createRequestObjectForGetEventDefs(DestId, Name, Id, startTime, endTime){
    let req = {
      DestId: DestId,
      Fields: {
        // name: Name,
        // id: Id,
        // startTime: startTime,
        // endTime: endTime
      }
    }
    return req
  }
  static _createRequestObjectForEditEvents(defId){
    let req = {
      EventDefIdList: {
        DefId : defId        
      },
      Fields: {
      }
    }

    return req
  }

  static _createRequestObjectForDestination(startHour, endHour, userId, destId){
    let req = {
      StartTime: startHour,
      EndTime: endHour,
      UserId: userId,
      DestinationId: destId
    }
    return req;
  }

  static _createRequestObjectForTripManager(startHour, endHour, userId, parentId){

    let req = {
      StartTime: startHour,
      EndTime: endHour,
      UserId: userId,
      ParentInstanceId: parentId
    }
    return req;
  }

  static _createRequestSaveEventSelection(finalEventTable, userId){
    let req = {
      UserId: userId,
      Events: finalEventTable
    }
    return req;
  }

  static _createRequestOrder(eventData){
    let req = {
      OrderId: eventData.OrderId,
      Version: eventData.Version
    }
    return req;
  }



}
